import React, { Component } from 'react';
import PropTypes from 'prop-types';

// share dependencies
import CardCta from 'share/components/layout/Izenda.CardCta';
import connect from 'share/enhancers/Izenda.Connect';
import RecentReportsViewContainer from './RecentReportsViewContainer';
import NLQSuggestionBox from 'share/components/controls/NLQSuggestionBox/Izenda.NLQSuggestionBox';
import { debounce } from 'lodash/fp';	
import { DEFAULT_DEBOUNCE_TIME } from 'logic/data/Izenda.UIConstants';

/**
 * @class NLQAsk
 * @description Renders the content of the first tab in NLQ Flow
 */
@connect()
class NLQAsk extends Component {
  constructor(props) {
    super(props);
    const { handleQueryChange } = props;
    this.onChangeWithDebounce = debounce(DEFAULT_DEBOUNCE_TIME, input => {
      handleQueryChange(input);
    });	
  }	

  handleQueryChange = (e) => {
    e.persist();
    const { value } = e.target;
    this.onChangeWithDebounce(value);
   };

  /**
   * @method renderCtas
   * @description render a CardCta component for each ctaContent object
   */
  renderCtas() {
    const {
      store: {
        ctaContent
      }
    } = this.props;

    return ctaContent.map(
      (cta, index) => <CardCta 
                label={cta.label} 
                description={cta.description}
                path={cta.path}
                imageModifier={cta.imageModifier} 
                key={index}
              />
    );
  }

  render() {
    const {
      handleQueryChange,
      onEnter,
      onSearch,
      onSelectedSuggestion,
      previewReport,
      store: {
        model: {
          recentReportViewList,
          showResult,
          searchString 
        },
        getNoConfigPlaceHolder,
        getNLQStatus,
        getactiveTab,
        getSetResults,  
      },
      disabledWrapper,
      authorization
    } = this.props;
    const isIntegrationMode =authorization.isIntegrationMode();
    return (
      <div>
        <NLQSuggestionBox
          showResult={showResult}
          placeholder={getNoConfigPlaceHolder}
          value={searchString}
          onKeyPress={onEnter}
          shouldFocus={true}
          disabled={getNLQStatus}
          onChange={this.handleQueryChange}
          isActive={getactiveTab == 1 ? true : false}
          suggestionList={getSetResults}
          onSearch={onSearch}
          onSelectedSuggestion={onSelectedSuggestion}
          disabledWrapper={disabledWrapper}
        />
       {
          (!isIntegrationMode)&&
          <div className="izenda-explore-container">
            <div className="izenda-explore-ctas">
              {this.renderCtas()}
            </div>
          </div>
        }
        {
          ( !isIntegrationMode &&
            recentReportViewList &&
            recentReportViewList.length > 0
          ) &&
          <RecentReportsViewContainer
            recentReportViewList={recentReportViewList}
            preview={previewReport}
          />
        }
      </div>
    );
  }
}

/**
 * @property propTypes
 * @description property types for NLQAsk
 * @type {function} handleQueryChange: callback for when the query changes
 * @type {function} onEnter: callback for when the user presses enter
 * @type {function} onSearch: callback for when the user clicks search
 * @type {function} onSelectedSuggestion: callback when when the user selects a suggested query
 * @type {function} previewReport: callback for when the user clicks on a recent report
 * @type {object} store: instance of ExploreStore
 */
NLQAsk.propTypes = {
  handleQueryChange: PropTypes.func.isRequired,
  onEnter: PropTypes.func.isRequired,
  onSearch: PropTypes.func.isRequired,
  onSelectedSuggestion: PropTypes.func.isRequired,
  previewReport: PropTypes.func.isRequired,
  store: PropTypes.object.isRequired
};

export default NLQAsk;



// WEBPACK FOOTER //
// ./ui/modules/Explore/NLQAsk/Izenda.NLQAsk.jsx